// extracted by mini-css-extract-plugin
module.exports = {"cell":"cell_cell__1XziB","cellSelected":"cell_cellSelected__1EwEu"};